/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var Activity;
(function (Activity) {
    /**
     * The source event that has yielded the activity.
     *
     * * `admin_credit` The account has been credited by Lune.
     * * `admin_debit` The account has been debited by Lune.
     * * `order_received` The account has placed an order and Lune has received it.
     * * `order_placed` An order has been matched to bundles. Quantites and costs are known and have been set.
     * * `order_paid` The order has been paid for.
     * * `order_retiring` Lune has started retiring the order's carbon offsets.
     * * `order_cancelled` The order has been cancelled
     * * `order_allocation_retired` Carbon credits linked to a specific project have been retired
     * * `order_complete` All carbon credits linked to the order have been retired
     * * `order_failed` Order failed to process.
     *
     */
    let source;
    (function (source) {
        source["ADMIN_CREDIT"] = "admin_credit";
        source["ADMIN_DEBIT"] = "admin_debit";
        source["ORDER_RECEIVED"] = "order_received";
        source["ORDER_PLACED"] = "order_placed";
        source["ORDER_PAID"] = "order_paid";
        source["ORDER_RETIRING"] = "order_retiring";
        source["ORDER_CANCELLED"] = "order_cancelled";
        source["ORDER_ALLOCATION_RETIRED"] = "order_allocation_retired";
        source["ORDER_COMPLETE"] = "order_complete";
        source["ORDER_FAILED"] = "order_failed";
    })(source = Activity.source || (Activity.source = {}));
})(Activity || (Activity = {}));
//# sourceMappingURL=Activity.js.map